module.exports = __webpack_public_path__ + "img/dnv_valid.cf53c9e9.png";